(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("selectTree", [], factory);
	else if(typeof exports === 'object')
		exports["selectTree"] = factory();
	else
		root["selectTree"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selectTree',
  props: {
    treeData: {
      type: Array
    },
    value: {},
    filterable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      queryVal: '',
      hideValue: '',
      valueType: 'string',
      selectNode: [],
      multipleShowVal: [],
      multipleHideVal: [],
      showTree: false,
      iconVal: 'ios-arrow-down',
      cloneData: JSON.parse(JSON.stringify(this.treeData)),
      showData: [],
      queryData: [],
      queryTreeVal: ''
    };
  },

  methods: {
    clickIcon: function clickIcon() {
      if (this.iconVal === 'ios-close-circle') {
        this.clearVal();
      } else {
        this.showSelectTree();
      }
    },
    pickTree: function pickTree(val) {
      if (this.valueType === 'string') {
        for (var i = 0; i < this.showData.length; i++) {
          if (this.showData[i].value === val) {
            this.showData[i].selected = false;
          } else if (this.showData[i].children !== undefined) {
            this.recursionPickTree(val, this.showData[i].children);
          }
        }
      } else {
        for (var j = 0; j < val.length; j++) {
          for (var _i = 0; _i < this.showData.length; _i++) {
            if (this.showData[_i].value === val[j]) {
              this.showData[_i].selected = false;
            } else if (this.showData[_i].children !== undefined) {
              this.recursionPickTree(val[j], this.showData[_i].children);
            }
          }
        }
      }
    },
    recursionPickTree: function recursionPickTree(val, data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].value === val) {
          data[i].selected = false;
        } else if (data[i].children !== undefined && data[i].children.length > 0) {
          this.recursionPickTree(val, data[i].children);
        }
      }
    },
    selectTreeChange: function selectTreeChange() {
      this.queryData = JSON.parse(JSON.stringify(this.showData));
      if (this.queryTreeVal !== '') {
        var removeData = [];
        for (var i = 0; i < this.queryData.length; i++) {
          var check = this.recursionTreeData(this.queryTreeVal, this.queryData[i]);
          if (!check) {
            removeData.push(i);
          }
        }
        this.queryData = this.queryData.filter(function (o, index) {
          return !removeData.includes(index);
        });
      }
    },
    recursionTreeData: function recursionTreeData(query, data) {
      var isCheck = false;
      var removeData = [];
      // 只验证最底层的节点是否有符合要求的值
      if (data.children !== undefined) {
        for (var i = 0; i < data.children.length; i++) {
          if (!isCheck) {
            isCheck = this.recursionTreeData(query, data.children[i]);
            if (!isCheck) {
              removeData.push(i);
            }
          } else {
            if (!this.recursionTreeData(query, data.children[i])) {
              removeData.push(i);
            }
          }
        }
      } else {
        // 验证当前节点是否有符合要求的值
        if (data.title.indexOf(query) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      data.children = data.children.filter(function (o, index) {
        return !removeData.includes(index);
      });
      // 如果子节点中有一个符合要求，则父节点就直接返回true，不做删除，若子节点没有一个符合要求，则再次验证当前的节点
      if (isCheck) {
        return isCheck;
      }
      // 表示当前的节点有值在里面
      if (data.title.indexOf(query) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    clearVal: function clearVal() {
      if (this.clearable && !this.multiple && this.iconVal === 'ios-close-circle') {
        this.pickTree(this.hideValue);
        this.queryVal = '';
        this.hideValue = '';
        if (this.showTree) {
          this.iconVal = 'ios-arrow-up';
        } else {
          this.iconVal = 'ios-arrow-down';
        }
        this.$emit('input', '');
      }
    },
    mouseover: function mouseover() {
      if (this.clearable && !this.multiple && this.iconVal !== 'ios-close-circle' && this.hideValue !== '') {
        this.iconVal = 'ios-close-circle';
      }
    },
    mouseleave: function mouseleave() {
      if (this.clearable && !this.multiple) {
        if (this.showTree) {
          this.iconVal = 'ios-arrow-up';
        } else {
          this.iconVal = 'ios-arrow-down';
        }
      }
    },
    selectChange: function selectChange(obj) {
      if (this.multiple) {
        this.multipleShowVal = [];
        this.multipleHideVal = [];
        for (var i = 0; i < obj.length; i++) {
          this.multipleShowVal.push(obj[i].title);
          this.multipleHideVal.push(obj[i].value);
        }
        this.$emit('input', this.multipleHideVal);
      } else {
        if (obj.length === 0) {
          this.queryVal = '';
          this.hideValue = '';
          this.$emit('input', '');
        } else {
          this.queryVal = obj[0].title;
          this.hideValue = obj[0].value;
          this.$emit('input', obj[0].value);
        }
        this.showTree = false;
        this.iconVal = 'ios-arrow-down';
      }
    },

    // 点击图标的时候展示树形菜单
    clickInputShow: function clickInputShow() {
      if (!this.multiple) {
        this.showSelectTree();
      } else if (this.iconVal !== 'ios-arrow-up') {
        this.showSelectTree();
      }
    },
    showSelectTree: function showSelectTree() {
      console.log('this.showTree=>' + this.showTree);
      if (this.showTree) {
        this.showTree = false;
      } else {
        this.showTree = true;
      }
      if (this.iconVal !== 'ios-close-circle') {
        if (this.iconVal === 'ios-arrow-down') {
          this.iconVal = 'ios-arrow-up';
        } else if (this.iconVal === 'ios-arrow-up') {
          this.iconVal = 'ios-arrow-down';
        }
      }
    },

    // 重置菜单的数据
    resetTreeData: function resetTreeData() {
      this.cloneData = JSON.parse(JSON.stringify(this.treeData));
    },

    // 多选模式的时候删除节点的数据
    removeVal: function removeVal(index) {
      for (var i = 0; i < this.showData.length; i++) {
        if (this.showData[i].value === this.multipleHideVal[index]) {
          this.hideValue = this.treeData[i].value;
          this.queryVal = this.treeData[i].title;
          this.showData[i].selected = false;
        } else if (this.showData[i].children !== undefined) {
          this.recursionRemoveTreeData(this.showData[i].children, this.multipleHideVal[index]);
        }
      }
      this.multipleShowVal.splice(index, 1);
      this.multipleHideVal.splice(index, 1);
    },
    recursionRemoveTreeData: function recursionRemoveTreeData(data, val) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].value === val) {
          data[i].selected = false;
          return;
        } else if (data[i].children !== undefined && data[i].children.length > 0) {
          this.recursionRemoveTreeData(data[i].children, val);
        }
      }
    },

    // 验证当前下拉
    checkValueType: function checkValueType() {
      if (typeof this.value !== 'string') {
        this.valueType = 'array';
      }
    },
    initQueryMultiple: function initQueryMultiple() {
      for (var i = 0; i < this.value.length; i++) {
        for (var j = 0; j < this.cloneData.length; j++) {
          if (this.cloneData[j].value === this.value[i]) {
            this.multipleShowVal.push(this.cloneData[j].title);
            this.multipleHideVal.push(this.cloneData[j].value);
            this.$emit('input', this.multipleHideVal);
            this.cloneData[j].selected = true;
            break;
          } else if (this.cloneData[j].children !== undefined) {
            this.recursionQueryTreeData(this.cloneData[j].children, this.value[i]);
          }
        }
      }
    },
    initQueryVal: function initQueryVal() {
      this.$emit('input', '');
      for (var i = 0; i < this.cloneData.length; i++) {
        if (this.cloneData[i].value === this.value) {
          this.hideValue = this.cloneData[i].value;
          this.queryVal = this.cloneData[i].title;
          this.$emit('input', this.cloneData[i].value);
          this.cloneData[i].selected = true;
          return;
        } else if (this.cloneData[i].children !== undefined) {
          this.recursionQueryTreeData(this.cloneData[i].children, this.value);
        }
      }
    },
    recursionQueryTreeData: function recursionQueryTreeData(data, val) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].value === val) {
          // 当前会多选
          if (this.multiple) {
            this.multipleShowVal.push(data[i].title);
            this.multipleHideVal.push(data[i].value);
            this.$emit('input', this.multipleHideVal);
          } else {
            this.hideValue = data[i].value;
            this.queryVal = data[i].title;
            this.$emit('input', data[i].value);
          }
          data[i].selected = true;
        } else if (data[i].children !== undefined) {
          this.recursionQueryTreeData(data[i].children, val);
        }
      }
    }
  },
  mounted: function mounted() {
    this.checkValueType();
    // 要先初始化选中的数据，再将初始化好的数据赋值给到当前的tree，否则将导致选中的效果显示不出来
    if (this.multiple) {
      this.initQueryMultiple();
    } else {
      this.initQueryVal();
    }
    this.showData = JSON.parse(JSON.stringify(this.cloneData));
    this.queryData = this.showData;
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectTree__ = __webpack_require__(2);
// selectTree 插件对应组件的名字

__WEBPACK_IMPORTED_MODULE_0__selectTree__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__selectTree__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__selectTree__["a" /* default */]);
}; //注册组件
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__selectTree__["a" /* default */]);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selectTree_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4927c786_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_selectTree_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selectTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4927c786_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_selectTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2e05695e", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".ivu-select-placeholder{color:#c5c8ce;padding-right:22px}.ivu-select-placeholder,.ivu-select-selected-value{display:block;height:30px;line-height:30px;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:8px}.ivu-select-selected-value{padding-right:24px}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ivu-select ivu-select-default"},[_c('div',{staticClass:"ivu-select-selection ivu-form-item-content",attrs:{"tabindex":"0"}},[_c('div',{on:{"mouseover":_vm.mouseover,"mouseleave":_vm.mouseleave}},[_c('div',{on:{"click":_vm.clickInputShow}},[_vm._l((_vm.multipleShowVal),function(item,index){return (_vm.multiple)?_c('div',{key:item,staticClass:"ivu-tag ivu-tag-checked "},[_c('span',{staticClass:"ivu-tag-text "},[_vm._v(_vm._s(item))]),_vm._v(" "),_c('i',{staticClass:"ivu-icon ivu-icon-ios-close",on:{"click":function($event){return _vm.removeVal(index)}}})]):_vm._e()}),_vm._v(" "),(!_vm.multiple && _vm.queryVal!='')?_c('span',{staticClass:"ivu-select-selected-value"},[_vm._v(_vm._s(_vm.queryVal))]):_vm._e(),_vm._v(" "),(_vm.multipleHideVal.length === 0 && _vm.multiple )?_c('span',{staticClass:"ivu-select-placeholder"},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),(_vm.value === '' && !_vm.multiple )?_c('span',{staticClass:"ivu-select-placeholder"},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}})],2),_vm._v(" "),_c('i',{class:'ivu-icon ivu-icon-' +_vm.iconVal+ ' ivu-select-arrow',on:{"click":_vm.clickIcon}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTree),expression:"showTree"}],staticClass:"ivu-select-dropdown",staticStyle:{"max-height":"200px","overflow-y":"scroll","z-index":"9999","width":"100%"}},[_c('div',{staticStyle:{"width":"95%","margin-left":"10px"}},[_c('Input',{attrs:{"placeholder":"请输入筛选条件"},on:{"on-change":_vm.selectTreeChange},model:{value:(_vm.queryTreeVal),callback:function ($$v) {_vm.queryTreeVal=$$v},expression:"queryTreeVal"}})],1),_vm._v(" "),_c('Tree',{ref:"tree",attrs:{"data":_vm.queryData,"multiple":_vm.multiple},on:{"on-select-change":_vm.selectChange}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// selectTree.js